var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"muit-home"},[_c('div',{staticClass:"button-section"},[_c('button',{staticClass:"btn primary-btn",on:{"click":_vm.goToTest}},[_vm._v("进入测评")]),_c('button',{staticClass:"btn secondary-btn",on:{"click":_vm.goToResult}},[_vm._v("\n      查看测评结果\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }